<style lang="less" scoped>
  .btn {
    margin-bottom: 24px;
  }
  .logo {
    width: 130px;
    height: 130px;
  }
</style>

<template lang="pug">
  .main.std-layout
    .content
      img.logo(:src='"@/assets/logo.png"')
    .btn-area
      button-component.btn(
        @click='$router.push(`/time`)'
        :text='"타임어택"')
      button-component.btn(
        @click='$router.push(`/training`)'
        :text='"훈련하기"')
</template>

<script>
import HeaderComponent from '@/components/header/back';
import ButtonComponent from '@/components/button';

export default {
  components: {
    HeaderComponent,
    ButtonComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/main.vue